import { ProjectOwnership } from 'types/data/projects/constants';
import { Select } from 'components/UI/Interactables/Select';
import { MediaQueries } from 'environment';
import { Container, DivTab as Tab, NormalTab, Text } from '../Tab.style';
import { useTranslation, useActiveProjectOwnership } from 'hooks/store';
import { useMediaQuery, useSelector } from 'hooks/utils';
import {
	ProjectInvitationStatus,
	useProjectInvitations
} from 'features/invite-users/useProjectInvitations';
import { LanguageType } from 'types/enums';

const tabsProps = {
	width: 14.3,
	min_width: 14.3,
	underline_width: 7.1
};

export function ProjectListTabs() {
	const { translate } = useTranslation();
	const language = useSelector(state => state.ui.i18n.language);
	const dictionary = DICTIONARY[language];
	const [{ data: activeOwnership }, setActiveOwnership] = useActiveProjectOwnership();
	const { invitations } = useProjectInvitations();

	function isActive(tab: ProjectOwnership) {
		return activeOwnership === tab;
	}

	const isPhone = useMediaQuery(
		`only screen and ${MediaQueries.minWidth.xs} and ${MediaQueries.maxWidth.sm}`
	);

	const menuTabs = [
		{
			label: dictionary.allProjectsHeader,
			value: ProjectOwnership.All
		},
		{
			label: dictionary.myProjectsHeader,
			value: ProjectOwnership.Own
		},
		{
			label: dictionary.sharedWithMeHeader,
			value: ProjectOwnership.SharedWithMe
		},
		{
			label: dictionary.invitationsHeader,
			value: ProjectOwnership.Invitations
		}
	];

	const projectPendingInvitations = invitations?.filter(
		invitation => invitation.status === ProjectInvitationStatus.PENDING
	);

	return (
		<Container>
			{isPhone ? (
				<NormalTab>
					<Select
						title={translate(dict => dict.terms.menu)}
						className="dropdown-tab"
						items={menuTabs}
						type={s => s.Tab(true)}
						activeItem={item => isActive(item.value as Partial<ProjectOwnership>)}
						onSelect={item =>
							setActiveOwnership(item.value as Partial<ProjectOwnership>)
						}
					/>
				</NormalTab>
			) : (
				<>
					{menuTabs.map(tab => (
						<Tab
							key={tab.label}
							active={isActive(tab.value)}
							onClick={() => setActiveOwnership(tab.value)}
							{...tabsProps}
						>
							<div>
								<Text>{tab.label}</Text>
								{tab.value === ProjectOwnership.Invitations &&
									projectPendingInvitations &&
									projectPendingInvitations.length > 0 && (
										<span className="bg-red-600 text-white rounded-full w-5 h-5 inline-flex items-center justify-center text-xs mr-1">
											{projectPendingInvitations.length}
										</span>
									)}
							</div>
						</Tab>
					))}
				</>
			)}
		</Container>
	);
}

const DICTIONARY = {
	[LanguageType.English]: {
		allProjectsHeader: 'All Projects',
		myProjectsHeader: 'My Projects',
		sharedWithMeHeader: 'Shared With Me',
		invitationsHeader: 'Invitations'
	},
	[LanguageType.Norwegian]: {
		allProjectsHeader: 'Alle prosjekter',
		myProjectsHeader: 'Mine prosjekter',
		sharedWithMeHeader: 'Delte med meg',
		invitationsHeader: 'Invitasjoner'
	}
};
